<template>
    <div class="side">
        <ul>
            <li class="cursor">
                <img class="item" src="static/index-icon-consulting-default.png" alt="">
                <img class="item-hover" src="static/index-icon-consulting-hover.png" alt="">
            </li>
            <li class="cursor phone">
                <img class="item" src="static/index-icon-phone-default.png" alt="">
                <img class="item-hover" src="static/index-icon-phone-hover.png" alt="">
                <span class="hover">咨询热线：400-870-3700</span>
            </li>
            <li class="cursor rcode">
                <img class="item" src="static/index-icon-scanning-default.png" alt="">
                <img class="item-hover" src="static/index-icon-scanning-hover.png" alt="">
                <img class="item-hover qc" src="../assets/img/qc.png" alt="">
            </li>
            <li class="cursor" @click="toTop()">
                <img class="item" src="static/index-icon-top-default.png" alt="">
                <img class="item-hover" src="static/index-icon-top-hover.png" alt="">
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "sidelink",
        methods: {
            toTop() {
                let timer;
                timer = setInterval(()=>{
                    document.documentElement.scrollTop= document.documentElement.scrollTop-document.documentElement.scrollTop/3;
                    if (document.documentElement.scrollTop<=20){
                        clearInterval(timer)
                    }
                },60)
            }
        }
    }
</script>

<style scoped>
    .side {
        width: 50px;
        height: 200px;
        position: fixed;
        top: 440px;
        right: 30px;
        z-index: 999;
    }

    li {
        width: 50px;
        height: 50px;
        display: block;
        background-color: #0089ff;
        margin-bottom: 3px;
    }

    li.white {
        background-color: white;
    }

    li:hover img.item {
        display: none;
    }

    li:hover img.item-hover {
        display: block;
    }

    img.item-hover {
        display: none;
    }

    span.hover {
        background-color: rgba(0, 0, 0, .5);
        color: #fff;
        position: absolute;
        top: 55px;
        left: -200px;
        padding: 10px;
        border-radius: 6px;
        display: none;
    }

    li.phone:hover span.hover {
        display: block;
    }

    img.qc {
        position: absolute;
        top: 85px;
        left: -120px;
        width: 100px;
        height: 100px;
    }

</style>